import React from "react";
import "./FinishNoteEdit.css";

function FinishNoteEdit(props: {callback: () => void}): JSX.Element {
    return (
        <div className="finishNoteEdit" onClick={props.callback}>
            <p className="finishNoteEditText">Finish</p>
        </div>
    )
}

export default FinishNoteEdit;